import Component from '../inherited/Component'
import Helpers from '../lib/Helpers'

class RangeSlider extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._rangeElem = this._elem.querySelector('[data-range-slider-elem]')

    this._minus = this._elem.querySelectorAll('[data-minus]')
    this._plus = this._elem.querySelectorAll('[data-plus]')

    this._minInput = document.querySelector(this._options.minElem)
    this._maxInput = document.querySelector(this._options.maxElem)

    this._min = this._elem.querySelectorAll('[data-min]')
    this._max = this._elem.querySelectorAll('[data-max]')
  }
 
  async mount () {
    const noUiSlider = await import('nouislider')
    noUiSlider.create(this._rangeElem, this._options)

    this._rangeElem.noUiSlider.on('update', e => {
      if (this._options.callComponent) {
        let comp = this._theme.getComponent(this._options.callComponent).component
        comp[this._options.callMethod](Number(this._rangeElem.noUiSlider.get()))        
      } 

      for (let elem of this._min) {
        elem.innerHTML = Helpers.formatMoney(Math.floor(this._rangeElem.noUiSlider.get()[0] * 100.00), this._ctx.getState())
      }

      for (let elem of this._max) {
        elem.innerHTML = Helpers.formatMoney(Math.floor(this._rangeElem.noUiSlider.get()[1] * 100.00), this._ctx.getState())
      }

    })

    this._rangeElem.noUiSlider.on('slide', e => {
      console.log(Math.floor(this._rangeElem.noUiSlider.get()[0]), Math.floor(this._rangeElem.noUiSlider.get()[1]))
      // console.log(maxValue);   
      this._minInput.value = Math.floor(this._rangeElem.noUiSlider.get()[0])
      this._maxInput.value = Math.floor(this._rangeElem.noUiSlider.get()[1])
      this._minInput.dispatchEvent(new Event('change'))
      this._maxInput.dispatchEvent(new Event('change'))
    })

    this._rangeElem.noUiSlider.on('set', e => {
      console.log(Math.floor(this._rangeElem.noUiSlider.get()[0]), Math.floor(this._rangeElem.noUiSlider.get()[1]))
      // console.log(maxValue);   
      this._minInput.value = Math.floor(this._rangeElem.noUiSlider.get()[0])
      this._maxInput.value = Math.floor(this._rangeElem.noUiSlider.get()[1])
      this._minInput.dispatchEvent(new Event('change'))
      this._maxInput.dispatchEvent(new Event('change'))
      for (let event of this._options.eventsOnUpdate) {
        let elem = document.querySelector(this._options.formParent)
        elem.dispatchEvent(new Event(event))
      }
    })


    for (let elem of this._minus) {
      elem.addEventListener('click', e => {
        let currentValue = Number(this._rangeElem.noUiSlider.get())
        this._rangeElem.noUiSlider.set(currentValue - 1)
      })
    }
    
    for (let elem of this._plus) {
      elem.addEventListener('click', e => {
        let currentValue = Number(this._rangeElem.noUiSlider.get())
        this._rangeElem.noUiSlider.set(currentValue + 1)
      })
    }
  }
}

export default RangeSlider
